import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class ListeService {
	constructor(private http: HttpClient) { }

	get(_id: string, _options: any = [], _nodata?: boolean): Observable<JSONRpcResponse> {
		let json = {
			jsonrpc: '2.0',
			method: 'webservice.liste:get',

			params: {
				id: _id,
				options: _options,
			},
		}

		if (_nodata) {
			json['params']['options']['nodata']=_nodata
			/*json['params']['options'] = {
				nodata: _nodata,
			}*/
		}
		let rpcMethod = new JSONRpc(json)

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	export(_id: string, _options: any = [], _nodata?: boolean): Observable<JSONRpcResponse> {
		let json = {
			jsonrpc: '2.0',
			method: 'webservice.liste:export',

			params: {
				id: _id,
				options: _options,
			},
		}

		if (_nodata) {
			json['params']['options'] = {
				nodata: _nodata,
			}
		}
		let rpcMethod = new JSONRpc(json)

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	exports(_id: string,dossier: any = [], _options: any = [], _nodata?: boolean): Observable<JSONRpcResponse> {
		let json = {
			jsonrpc: '2.0',
			method: 'webservice.liste:exports',

			params: {
				id: _id,
				dossier: dossier,
				options: _options,
			},
		}

		if (_nodata) {
			json['params']['options'] = {
				nodata: _nodata,
			}
		}
		let rpcMethod = new JSONRpc(json)

		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	
	setfilter(id: any, libelle: any, filters: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:setfilter',
			params: {
				id: id,
				libelle: libelle,
				filters: filters,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	removefilter(id: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:removefilter',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getTriggers(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:getTriggers',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	getConsultationList(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:getConsultationList',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getActionsList(options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:getActionsList',
			params: {
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	getFilterList(id: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.liste:filterlist',
			params: {
				id: id
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	
	
	
}
